async function processInvoice(fileUrl) {
  try {
    // const response = await fetch(
    //   "http://192.168.1.146:8080/api/extract-invoice",
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       pdfUrl: fileUrl,
    //     }),
    //   }
    // );
    const response = await fetch(
      "https://pdf-extractor-with-python-dot-charming-shield-300804.uc.r.appspot.com/api/extract-invoice",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pdfUrl: fileUrl,
        }),
      }
    );
    // const response = await fetch("http://localhost:3004/api/extract-invoice", {

    const data = await response.json();
    console.log("processInvoice : ", JSON.stringify(data));
    return { status: "success", data: data };
  } catch (error) {
    console.error("Error extracting invoice data:", error);
    return { status: "failed", data: null };
  }
}

export default processInvoice;
